import { SortableTreeWithoutDndContext } from "react-sortable-tree";
import { withUniversalDnd } from "./UniversalDragAndDrop";

const UniversalSortableTree = props => {
    const UST = withUniversalDnd(SortableTreeWithoutDndContext);
    return <UST {...props} />;
};
export default UniversalSortableTree;
